import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const FollowUp = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
      fill={fill}
    >
      <path d="M15.333 2.667h-7L6.333 0H.667A.667.667 0 0 0 0 .667v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3.333a.667.667 0 0 0-.667-.666zM10.8 9.154 8 12 5.2 9.154a1.867 1.867 0 0 1 0-2.613 1.8 1.8 0 0 1 2.8.286 1.8 1.8 0 0 1 2.8-.286 1.867 1.867 0 0 1 0 2.613z" />
    </svg>
  );
};

FollowUp.displayName = 'FollowUp';
